function normalizeResults(payload) {
  if (Array.isArray(payload)) return payload
  return payload && Array.isArray(payload.results) ? payload.results : []
}

function orderedItems(items) {
  return [...(items || [])].sort((left, right) => {
    return left.display_order - right.display_order || left.id - right.id
  })
}

function collectTags(releases) {
  const tags = new Map()
  ;(releases || []).forEach(release => {
    ;(release.tags || []).forEach(tag => tags.set(tag.id, tag))
  })
  return [...tags.values()].sort((left, right) => {
    return left.label.localeCompare(right.label) || left.id - right.id
  })
}

module.exports = {
  collectTags,
  normalizeResults,
  orderedItems
}
